
<template>
  <div id="app">

    <div class="wrapper">
	<a href="https://bizstudy.useschool.co.kr/" v-if="this.persistent.buildTarget == 'b2b'"><img src="https://useschool.co.kr/UbestA/ubesta2_new/img/btn_home.png" style="position: absolute; top: 10px; left: 10px;"></a>
  <a href="https://study.useschool.co.kr/" v-if="this.persistent.buildTarget == 'b2c'"><img src="https://useschool.co.kr/UbestA/ubesta2_new/img/btn_home.png" style="position: absolute; top: 10px; left: 10px;"></a>
      <div class="line_box" style="margin-bottom: 40px; background: none; text-align: center;">
        <img src="https://childu.co.kr/img/title_b2b.png" v-if="this.persistent.buildTarget == 'b2b'">
        <img src="./assets/img/title.png" v-else>
      </div>

      <br>
      <br>
      <br>

      <div class="line_box">
        <div class="view_avatar">
          <div
            style="width: 96%; margin: 0 auto; height: 100px; background: #2b2929; text-align: center; color: #fff; position: absolute; border-radius: 10px; top:-50px;left:10px;">

            <div style="position: absolute; top:-35px; right: 12px; "><a :href="this.persistent.buildTarget == 'b2b' ? 'https://bizstudy.useschool.co.kr/UbestA/Ubesta2_new/point_info.asp' : 'https://useschool.co.kr/UbestA/Ubesta2_new/point_info.asp'" target="_blank">

          </a></div>
            <table width="98%" border="0" style="font-size: 12px; margin-top: 16px;">
              <tbody>

                <tr>
                  <td height="34"><img src="./assets/img/icon_fame.png"></td>
                  <td height="34"><img src="./assets/img/icon_alpha.png"></td>
                  <td height="34"><img src="./assets/img/icon_carat.png"></td>
                </tr>

                <tr style="border-top: 1px solid #353535;" >
                  <td height="34" valign="middle" ><span
                      style="color:#fff; font-size: 17px; font-weight: 500; text-align: center;">{{ myInfo.balance.FAME.toLocaleString() }}점</span></td>
                  <td height="34" valign="middle"><span
                      style="color: #fff; font-size: 17px; font-weight: 500; text-align: center;">{{ myInfo.balance.alpha.toLocaleString()}}점</span></td>
                  <td height="34" valign="middle" style="padding-top:6px;"><span
                      style="color: #fff; font-size: 17px; line-height:10px;  font-weight: 500; text-align: center;">{{ myInfo.balance.carat.toLocaleString()}}점<span style="color: #ffcc00;font-size: 13px" v-if="myInfo.balance.carat_in_hold"><br>(사용가능: {{ (myInfo.balance.carat - myInfo.balance.carat_in_hold).toLocaleString() }}점)</span></span></td>
                </tr>
              </tbody>
            </table>


          </div>
          <br>
          <!-- <img src="https://www.useschool.co.kr/img/main_img/silver_female_img.png" -->
            <!-- style="width: 380px; margin-top: 20px; text-align: center;"> -->

			<!-- 남자일 경우 -->
            <img src="//avatar.useschool.co.kr/avatar/img/boy.png" :style="'width: 380px; margin-top: 20px; text-align: center; z-index: 11;' + (myInfo.set.item ? 'visibility:hidden;' : '')" v-if="myInfo.gender == 1">
			<!-- 여자일 경우 -->
			<img src="//avatar.useschool.co.kr/avatar/img/girl.png" :style="'width: 380px; margin-top: 20px; text-align: center; z-index: 111;' + (myInfo.set.item ? 'visibility:hidden;' : '')" v-if="myInfo.gender == 2">

          <div style="" class="view_item_box" style="position: absolute; top: 70px; left: 40px; z-index: 100;" @click="unequipItem('hair')"><img v-if="myInfo.hair.item && !myInfo.hair.item.hide_equip" :src="'//avatar.useschool.co.kr//avatar/img/item/hair/' + myInfo.hair.item.code + '.png'"
              style="width: 100%;"></div>
          <div style="position:absolute; top:130px; left: 40px;z-index:100;" class="view_item_box" @click="unequipItem('clothes')"><img v-if="myInfo.clothes.item" :src="'//avatar.useschool.co.kr//avatar/img/item/clothes/' + myInfo.clothes.item.code + '.png'"
              style="width: 100%;"></div>
          <div style="position:absolute; top:190px; left: 40px;z-index:100;" class="view_item_box" @click="unequipItem('shoes')"><img v-if="myInfo.shoes.item" :src="'//avatar.useschool.co.kr//avatar/img/item/shoes/' + myInfo.shoes.item.code + '.png'"
              style="width: 100%;"></div>
          <div style="position:absolute; top:190px; left: 370px;z-index:100;" class="view_item_box" @click="unequipItem('weapon')"><img v-if="myInfo.weapon.item" :src="'//avatar.useschool.co.kr//avatar/img/item/weapon/' + myInfo.weapon.item.code + '.png'"
              style="width: 100%;"></div>
              <div style="position:absolute; top:250px; left: 370px;z-index:100;" class="view_item_box" @click="unequipItem('pet')"><img v-if="myInfo.pet.item" :src="'//avatar.useschool.co.kr//avatar/img/item/pet/' + myInfo.pet.item.code + '.png'"
              style="width: 100%;"></div>
              <div style="position:absolute;z-index:20; top:310px; left: 370px;z-index:100;" class="view_item_box" @click="unequipItem('face')"><img v-if="myInfo.face.item" :src="'//avatar.useschool.co.kr//avatar/img/item/face/' + myInfo.face.item.code + '.png'"
              style="width: 100%;"></div>

          <br>
			<!-- 아바타 장착 부위 -->
			<!-- 아바타 장착 부위 -->
      <!-- <img src="/avatar/img/boy.png" style="width: 380px; margin-top: 20px; text-align: center; z-index: 11;visibility: hidden;"> -->
			<!-- 머리부분
			<img src="/avatar/img/item/hair/girl_hair_2.png" style=" text-align: center; z-index: 9; position: absolute; top:28px; left: 87px; width: 300px;">

<!-- 여자머리 -->
         <img v-if="myInfo.hair.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/hair/' + myInfo.hair.item.code + '.png'" style="text-align: center; z-index: 9; position: absolute; top:43px; left: 38px; width: 382px;">
         <img v-if="myInfo.clothes.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/clothes/' + myInfo.clothes.item.code + '.png'" style="text-align: center; z-index: 10; position: absolute; top:45px; left: 40px; width: 378px;">
          <img v-if="myInfo.shoes.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/shoes/' + myInfo.shoes.item.code + '.png'" style="text-align: center; z-index: 9; position: absolute; top:54px; left: 44px; width: 369px; ">
          <img v-if="myInfo.weapon.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/weapon/' + myInfo.weapon.item.code + '.png'" style="text-align: center; z-index: 99; position: absolute; top:95px; left: 67px; width: 300px;">
          <img v-if="myInfo.pet.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/pet/' + myInfo.pet.item.code + '.png'" style="text-align: center; z-index: 99; position: absolute; top:-60px; left:-32px;">
          <img v-if="myInfo.face.item && !myInfo.set.item" :src="'//avatar.useschool.co.kr//avatar/img_2/avatarshop-main/face/' + myInfo.face.item.code + '.png'" style="text-align: center; z-index: 8; position: absolute; top:45px; left:40px;width: 378px;">



        <div style=" color:#fff; font-size:16px; line-height:62px;  font-style: italic;  font-weight:bold; padding:0px 10px; border-radius:4px; background:url('https://childu.co.kr/img/bg_tier.png') no-repeat; width:229px; position: absolute; height:59px; top:390px; left:100px;" class="tier_tag" v-if="myInfo.tier">{{ myInfo.tier.Tier }}</div>
          <div class="view_item_detail">
<a :href="this.banner.href">
<img :src="this.banner.src" />
</a>
            </a>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col">
              <ul class="nav nav-pills" style="width:700px;">
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/hair/1">헤어</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/clothes/1">옷&nbsp;</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/weapon/1">액세서리</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/shoes/1">신발</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/face/1">표정</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/shop/pet/1">펫</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/box">보물상자</router-link>
                </li>

                <li class="nav-item">
                  <router-link class="nav-link" to="/my_room/inventory/1">My room</router-link>
                </li>
              </ul>

              <div class="tab-content">
                                  <div class="part_avatar">
                <router-view/>
                </div>

              </div>
            </div>

          </div>
        </div>




      </div>



      <!--wrapper -->
    </div>


    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->


<!--선물도착 알림-->
<div class="modal fade notifications" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-modal="true" v-for="notification in myInfo.notifications" :key="notification.id">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius:0.5rem;">
            <div class="modal-header" style="background:rgb(52 52 52);">
                <h5 class="modal-title" id="exampleModalLongTitle" style="width:100%;">
                <div style="text-align:center; width:100%;"><span style="color:#ffcc00;">{{ notification.title }}</span>&nbsp;<span style="color:#fff;">알림</span></div>
                  </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color:#fff;">×</span>
                </button>
            </div>
            <div class="modal-body" style="text-align:center;">
              <img src="./assets/avamall_img_uzi1.png" v-if="notification.type == 'INCOMING_GIFT'">
              <img src="./assets/avamall_img_uzi2.png" v-if="notification.type == 'GIFT_ACCEPTED'">
              <img src="./assets/avamall_img_uz3i.png" v-if="notification.type == 'GIFT_REJECTED'">

              <p>
                {{ notification.text}}<br />
                <span style="color:rgb(52 52 52); font-weight:bold; font-size:18px;">"{{ notification.msg}}"</span>
                </p>
            </div>
            <div class="modal-footer">
                <router-link to="/my_room/gift/incoming/1" v-if="notification.type == 'INCOMING_GIFT'"><button type="button" class="btn btn-secondary" data-dismiss="modal" >선물 확인하기</button></router-link>
                <router-link to="/my_room/gift/outgoing/1" v-else><button type="button" class="btn btn-secondary" data-dismiss="modal" >보낸 선물함 확인하기</button></router-link>

            </div>
        </div>
    </div>
</div>





<!-- Modal -->
<div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="alertModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="alertModalLabel">메시지</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      {{ alertModal }}<br>
      </div>
      <div class="modal-footer" style="background:">
        <button type="button" class="btn btn-primary" data-dismiss="modal">확인</button>
      </div>
    </div>
  </div>
</div>
  </div>

</template>

<script>
import axios from 'axios';
window.$ = require('jquery')
window.JQuery = require('jquery')
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
    return {
      alertModal: "",
      myInfo: {box: {
        remainTime: 0
      },
      hair: [],
      clothes: [],
      weapon: [],
      shoes: [],
      set: [],
      face: [],
      pet: [],
      balance: {
        alpha: 0,
        FAME: 0,
        carat: 0
      },
      gender:1
      },
      loginID: 0,
      persistent: {
        buildTarget: "b2b",
        apiUrl: "https://api-bizavatar.useschool.co.kr/"
        // b2c빌드 / b2c / https://avatar.useschool.co.kr/avatar_sys/
        // b2b빌드 / b2b / https://api-bizavatar.useschool.co.kr/
      },
      banner: null,
      tiers: []
    }
  },
    methods: {
    fetchMyInfo() {
      console.log("fetching")
      if(!this.loginID) return;
        axios.get(this.persistent.apiUrl + 'retrieveInfo.php?uid=' + this.loginID)
        .then(response => {
            // console.log(response.data)
            this.myInfo = response.data
            /*this.myInfo.notifications = [
                {
                    "title": ".",
                    "text": ".",
                    "msg": "hello world",
                    "type": "INCOMING_GIFT"
                }
            ]*/
            $(document).ready(() => {
              $(".notifications").modal()
            })
        }).catch((error) => console.log(error));
    },
        alert(msg){
      this.alertModal = msg;
      $("#alertModal").modal()
    },
        unequipItem(part){
        axios.get(this.persistent.apiUrl + 'unequip.php?type=' + part + '&uid=' + this.loginID)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.alert(response.data.reason)
            } else {
              this.fetchMyInfo()
            }
        }).catch((error) => console.log(error));
    }
},
created(){
  this.loginID = localStorage.getItem('loginID')
  this.fetchMyInfo()
  setInterval(() => {
  // Code here
  // console.log(this);
  if(this.myInfo.box.remainTime > 0){
this.myInfo.box.remainTime--;
  }

  // console.log(this.myInfo.box.remainTime);
}, 1000);
},
mounted(){
        axios.get(this.persistent.apiUrl + 'getBanner.php')
        .then(response => {
            //console.log(response.data)
            //this.items = response.data.items
            if(response.data.status == "error"){
              this.alert(response.data.reason)
            } else {
              this.banner = response.data;
            }
            console.log(this.banner.href)
        }).catch((error) => console.log(error));
        axios.get(this.persistent.apiUrl + 'getTierTable.php')
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.alert(response.data.reason)
            } else {
              this.tiers = response.data.data
            }
        }).catch((error) => console.log(error));
},
    watch: {
    '$route.params': {
        handler(newValue) {
            // console.log(newValue)
            // if(!Object.keys(newValue).length && this.$route.name != "box"){
            //   console.log("null?")
            //   this.$router.push('/shop/set/1')
            // }
        },
        immediate: true,
    }
},
}
</script>

<style>
a:link{color:#fff;}
a:hover{color:#fff!important;}
*{padding: 0; margin: 0;}
.wrapper{width: 100%; background:url('https://avatar.useschool.co.kr/avatar/img/bg.png') no-repeat center center fixed; height:940px;
		-webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;
		}
.line_box{width: 1200px; margin: 0 auto; }
.view_avatar{width: 460px; float: left; height: 560px; text-align: center;background: url('https://avatar.useschool.co.kr/avatar/img/view_bg.jpg') no-repeat;position: relative; margin-right: 5px; border-radius: 5px; border: 1px solid #000;}
.part_avatar{width: 710px; background:rgba(23,23,23,0.9) no-repeat; float: left; height: 566px;  border-radius: 5px; padding: 20px; border:1px solid #000;box-shadow: 4px 2px 10px  #000;}
.view_item_box{width: 50px; height: 50px; background: #181818; border:2px solid  #3c3c3c; border-radius: 5px;}
.view_item_detail{width: 100%; margin: 0 auto;text-align:left; background: #353535; position: relative; top:0px; font-size: 12px; color: #fff; }
.item_box{width: 156px; height: 210px; border-radius: 5px; background: #343434; text-align: center; color: #fff; margin: 5px; float: left; padding: 10px;}
.item_box_gift{width: 320px; height: 210px; border-radius: 5px; background: #343434; text-align: center; color: #fff; margin: 5px; float: left; padding: 10px;}
.item_box_title{height: 25px; font-size: 12px;}
.item_box_item{width: 136px;height: 130px; font-size: 12px; background: #272728; border-radius: 5px;}
.item_box_item img {width: 100px; padding-top: 15px;}

.item_box_price{width: 80px; height: 24px; background: #272728; border-radius: 5px; font-size: 11px; line-height: 24px; float: left; margin-top: 2px; margin-right: 2px; color:#ffcd00;}
.item_box_buy{width: 38px; height: 24px; color: #272728; background: #ffcd00; border-radius: 5px; font-size: 12px; font-weight: bold;line-height: 24px; float: left; margin-top: 2px; cursor: pointer;}

.item_box_price_fame{width: 90px; height: 24px; background: #272728; border-radius: 5px; font-size: 14px; line-height: 24px; float: left; margin-top: 2px; margin-right: 6px; color:#4ad2ff;}
.item_box_buy_fame{width: 38px; height: 24px; color: #fff; border-radius: 4px; font-size: 11px; font-weight: bold;line-height: 24px; float: left; margin-top: 2px; cursor: pointer;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff3019+0,cf0404+100;Red+3D */
  background: #ff3019; /* Old browsers */
  background: -moz-linear-gradient(top,  #ff3019 0%, #cf0404 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top,  #ff3019 0%,#cf0404 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,  #ff3019 0%,#cf0404 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff3019', endColorstr='#cf0404',GradientType=0 ); /* IE6-9 */


}



.tab_box{width: 70px;  margin: 0 1px; background:#1d1d1d; border: 1px solid #000; text-align: center;height: 36px; line-height: 36px; color: #ffcd00; border: 1px solid #000; float: left; border-bottom: none; font-size: 12px;}
a:hover .tab_box{background: #ffcd00; color: #1d1d1d;}

  .nav-tabs{border: none;}
  a:hover .nav-tabs{color: #000;}
  .nav-link  {background: #202c4d; color: #fff; font-size: 12px; margin-right: 4px;font-weight: bold;  transition-duration: 0.4s; padding: 8px 22px!important; border:1px solid #0a132b;  border-bottom: none;}
  .nav-link hover{background: #fff;}
    a:link .nav-link{color: #ffcd00;}
   .nav-item a:hover {color: #333!important; background: #daff0c; border:1px solid #9fbc00;  border-bottom: none;transition-duration: 0.4s;font-weight: bold!important;}
   .nav-item a:focus {color: #333!important; background:#daff0c;  transition-duration: 0.4s;}

.gift_form{width: 95%;  line-height: 26px; background: #222; border-radius: 4px; padding: 0px 4px;}
.nav-pills .nav-link{border-radius: 0.25rem 0.25rem 0 0!important;}

@media all and (max-width:1210px){
	#app .nav-link {padding:.5rem;}
	.wrapper {height:100%; min-height:768px; padding:0 20px 20px;}
	.line_box {width:auto;}
	.line_box:after {display:block; content:''; clear:both;}
	#app .container {float:right; width:calc(100% - 480px); max-width:inherit; padding:0;}
	.part_avatar {width:100%; height:auto; padding:10px; }
	.item_box {width:150px;}
	.item_box_item {width:130px;}
	.item_box_price_fame {width:86px;}
}
.tier_tag{
background: #ffffff; /* Old browsers */
background: -moz-linear-gradient(top, #ffffff 0%, #f1f1f1 50%, #e1e1e1 51%, #f6f6f6 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(top, #ffffff 0%,#f1f1f1 50%,#e1e1e1 51%,#f6f6f6 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to bottom, #ffffff 0%,#f1f1f1 50%,#e1e1e1 51%,#f6f6f6 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f6f6f6',GradientType=0 ); /* IE6-9 */}



</style>
